/* see docs/EXTRACTED_COMMENTS.md#c061 */

import {
  InlineClassPicker,
  type PickerEntry,
  type PickerVariant,
} from "./InlineClassPicker"
import { toRgb } from "./colorUtils"
import { renderCustomColorControl } from "./customColorControl"
import type { ForegroundOption } from "./types"
import type { API } from "@editorjs/editorjs"

export class ForegroundPickerTool extends InlineClassPicker {
  static title = "Text colour"

  private colors: ForegroundOption[]

  constructor({
    api,
    config,
  }: {
    api: API
    config?: { colors?: ForegroundOption[] }
  }) {
    super({ api })
    this.colors = config?.colors ?? []
  }

  protected get pickerTitle(): string {
    return "Text colour"
  }

  protected get variant(): PickerVariant {
    return "swatch"
  }

  protected get colorProperty(): "color" {
    return "color"
  }

  protected get icon(): string {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <text x="12" y="15.5" text-anchor="middle" font-family="Georgia, 'Times New Roman', serif"
        font-size="15" font-weight="700" fill="currentColor">A</text>
      <rect x="5" y="18.5" width="14" height="3" rx="1.5" fill="currentColor"/>
    </svg>`
  }

  protected get entries(): PickerEntry[] {
    const clear: PickerEntry = {
      label: "None",
      className: "",
      style: { color: "inherit" },
      clear: true,
    }
    return [
      clear,
      ...this.colors.map(color => {
        const rgb = toRgb(color.color) ?? color.color
        return {
          label: color.label,
          className: color.className,
          style: { color: rgb },
          swatch: rgb,
        }
      }),
    ]
  }

  protected renderFreeControl(): HTMLElement {
    return renderCustomColorControl({
      initial: "#1f2937",
      onPreview: rgb =>
        this.previewEntry({ label: rgb, className: "", style: { color: rgb } }),
      onCommit: rgb =>
        this.applyEntry({ label: rgb, className: "", style: { color: rgb } }),
    })
  }
}
